module.exports = __webpack_public_path__ + "img/styrianner-header-img-v1.424c3918.jpg";